import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import Loader from 'components/partials/loader/loader';
import Breadcrumbs from 'components/partials/beadcrumbs/breadcrumbs';
import CriticalElement from 'containers/admin/clients/client/tabs-components/critical-elements/critical-elements-manager/critical-element/critical-element';
import ResponsiveWrapper from 'components/shared/others/responsive-wrapper/responsive-wrapper';

import api from 'api';

import {
  getBreadcrumbsForCriticalElement,
  getCommonRedirectLink,
} from 'containers/admin/clients/client/tabs-components/critical-elements/critical-elements-manager/critical-elements.helpers';

import { useClients } from 'state/clients/clients.thunk';
import { useCurrentUser } from 'state/current-user/current-user.thunk';

const CriticalElementPage = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { clientId, year, id: elementId } = params;
  const isNew = elementId === 'new';
  const redirectLink = getCommonRedirectLink(clientId, year);

  const currentUser = useCurrentUser();
  const userId = currentUser?.data?.oktaUserId;

  const [isEditMode, setIsEditMode] = useState(isNew);
  const [currentClient, setCurrentClient] = useState(null);
  const [criticalElement, setCriticalElement] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchCriticalElement = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.getCriticalElement({
        userId,
        clientId,
        id: elementId,
      });

      setCriticalElement(response.data);
    } catch (error) {
      console.error('Error fetching critical element:', error);
    } finally {
      setLoading(false);
    }
  }, [elementId, clientId, year]);

  useEffect(() => {
    if (!isNew) {
      fetchCriticalElement();
    } else {
      setLoading(false);
    }
  }, []);

  const clients = useClients();

  const handleSaveSuccess = () => {
    navigate(redirectLink);
  };

  const handleCancel = () => {
    navigate(redirectLink);
  };

  useEffect(() => {
    if (clientId) {
      clients
        .find(clientId)
        .then((response) => {
          setCurrentClient(response.data);
        })
        .catch((error) => {
          console.error('Error fetching client information:', error);
        });
    }
  }, [clientId]);

  if (loading) {
    return <Loader loading={true} />;
  }

  return (
    <ResponsiveWrapper>
      <Breadcrumbs
        breadcrumbs={getBreadcrumbsForCriticalElement(currentClient, year)}
      />
      <CriticalElement
        data={criticalElement}
        isEditMode={isEditMode}
        setIsEditMode={setIsEditMode}
        loading={loading}
        getElement={fetchCriticalElement}
        onSaveSuccess={handleSaveSuccess}
        onCancel={handleCancel}
        setLoading={setLoading}
      />
    </ResponsiveWrapper>
  );
};

export default CriticalElementPage;
